// Org access elevation: a Service Admin holding an approved access grant for another organization
// can "go to" that organization. The API scopes a request to it when the request carries the
// `X-Wave-OrgId` header (see ApolloProvider), and `query organization` then resolves to it — which
// is all the rest of the portal needs to render that organization instead of the user's own.
//
// The elevated organization lives in sessionStorage so it is scoped to the current tab and ends
// when the tab is closed, instead of silently carrying over to other tabs or later sessions.

const STORAGE_KEY = 'wave.elevatedOrganizationId';

export const ELEVATED_ORGANIZATION_HEADER = 'X-Wave-OrgId';

export function getElevatedOrganizationId(): string | null {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearElevatedOrganization() {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage unavailable — there is nothing to clear.
  }
}

/**
 * Switches the portal to `organizationId`, or back to the user's own organization when it is
 * `null` or the user's own organization. A full reload starts from a clean Apollo cache and lets
 * the app load the new organization and its routes the same way it does on sign-in.
 */
export function goToOrganization(organizationId: string | null, homeOrganizationId?: string) {
  try {
    if (organizationId === null || organizationId === homeOrganizationId) {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } else {
      window.sessionStorage.setItem(STORAGE_KEY, organizationId);
    }
  } catch {
    // Without storage there is no way to carry the elevation across the reload.
    return;
  }

  window.location.assign('/');
}
